import FBProvider from "./container/ProviderLanding";

export default FBProvider;
